// Keep in sync with maxChatMessageRunes in backend/internal/api/ws_limits.go.
export const MAX_CHAT_MESSAGE_RUNES = 8000;

export const CHAT_MESSAGE_TOO_LONG_COPY =
  "That message is too long. Please shorten it and try again.";

/** True when text exceeds the server cap. Counts code points like Go runes. */
export function chatMessageTooLong(text: string): boolean {
  // Fast path: UTF-16 length is an upper bound on the code point count.
  if (text.length <= MAX_CHAT_MESSAGE_RUNES) return false;
  return [...text].length > MAX_CHAT_MESSAGE_RUNES;
}
